
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseApprovalGrid extends _Ext.GridBase<ApprovalInItemsRow, any> {
        protected getColumnsKey() { return 'Purchase.ApprovalInItems'; }
        protected getDialogType() { return ApprovalInItemsDialog; }
        protected getIdProperty() { return ApprovalInItemsRow.idProperty; }
        protected getInsertPermission() { return ApprovalInItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalInItemsRow.localTextPrefix; }
        protected getService() { return PurchaseApprovalItemsService.baseUrl; }
        rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        protected getColumns() {

            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };

        constructor(container: JQuery, options) {
            super(container, options);
            var partyid = options.GridFilters.PartyId;
            if (partyid != null && partyid > 0)
                (this.view.params as TransactionRequest).PartyId = partyid;
            var instock = options.GridFilters.InStock;
            if (instock != null )
                (this.view.params as TransactionRequest).InStock = instock;
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        get selectedItems(): ApprovalInItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

    }

}
